import { create } from "zustand";
import { immer } from "zustand/middleware/immer";

type TState = {
  routes: {
    path?: string;
    name: string;
    search?: string;
    description?: string;
    helpLink?: string;
  }[];
};

type Actions = {
  setRoutes: (routes: TState["routes"]) => void;
};

const useBreadcrumbs = create<TState & Actions>()(
  immer((set) => ({
    routes: [],
    setRoutes(routes) {
      set((state) => {
        state.routes = routes;
      });
    },
  })),
);

export default useBreadcrumbs;
